"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _CategoryDropdown = _interopRequireDefault(require("@insided/shared/uikit/CategoryDropdown"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _categories = require("@insided/shared/utils/categories");

var _utils = require("@insided/control/modules/ContentModeration/TopicModeration/utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _utils2 = require("@insided/deprecated-control/category-select/utils");

var _LanguageSelector = _interopRequireDefault(require("@insided/control/modules/MultiLanguage/LanguageSelector"));

var _typeGuards = require("@insided/deprecated-libs/typeGuards");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var hasCategoryWithId = function hasCategoryWithId(categories, categoryId) {
  var category = (0, _categories.findCategoryById)(categories, categoryId);
  return !!category;
};

var getPublishingModule = function getPublishingModule(publishIn) {
  if (publishIn === 'knowledgeBase') return _categories.MODULE.KNOWLEDGE_BASE;
  if (publishIn === 'groups') return _categories.MODULE.GROUPS;
  return _categories.MODULE.COMMUNITY;
};

var filterCategoriesByType = function filterCategoriesByType(categories, publishIn, selectedLanguageCode) {
  if (!categories) return {};
  var key = getPublishingModule(publishIn);
  var type = (0, _categories.getTypeFromModuleName)(key);
  var filteredByModuleCategories = categories[type];

  if ((key === _categories.MODULE.KNOWLEDGE_BASE || key === _categories.MODULE.COMMUNITY) && selectedLanguageCode) {
    var filteredByLanguageCategories = filteredByModuleCategories.filter(function (category) {
      return !category.language || category.language === selectedLanguageCode;
    });
    return (0, _defineProperty2.default)({}, type, filteredByLanguageCategories !== null && filteredByLanguageCategories !== void 0 ? filteredByLanguageCategories : []);
  }

  return (0, _defineProperty2.default)({}, type, filteredByModuleCategories !== null && filteredByModuleCategories !== void 0 ? filteredByModuleCategories : []);
};

var CategorySelect = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategorySelect, _Component);

  var _super = _createSuper(CategorySelect);

  function CategorySelect() {
    var _this;

    (0, _classCallCheck2.default)(this, CategorySelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _this.getInitialState());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps, prevState) {
      var _this$props = _this.props,
          categoryId = _this$props.categoryId,
          categories = _this$props.categories,
          isKnowledgeBaseEnabled = _this$props.isKnowledgeBaseEnabled,
          isGroupsEnabled = _this$props.isGroupsEnabled;
      var publishIn = 'community';

      if (categoryId && categoryId !== prevProps.categoryId) {
        var groupedCategories = (0, _utils2.groupCategories)(categories, isKnowledgeBaseEnabled, isGroupsEnabled);

        if (hasCategoryWithId(groupedCategories.groups, categoryId)) {
          publishIn = 'groups';
        } else if (hasCategoryWithId(groupedCategories.knowledgeBase, categoryId)) {
          publishIn = 'knowledgeBase';
        }

        _this.setState({
          publishIn: publishIn
        });
      }

      var categoriesUpdated = _this.props.categories !== prevProps.categories;
      var publishInUpdated = _this.state.publishIn !== prevState.publishIn;

      if (categoriesUpdated || publishInUpdated) {
        _this.filterLanguages(publishInUpdated);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "filterLanguages", function (publishInUpdated) {
      var categoryV2Allowed = _this.props.categoryV2Allowed;

      if (categoryV2Allowed) {
        var _this$props$categorie;

        var categories = (_this$props$categorie = _this.props.categories) !== null && _this$props$categorie !== void 0 ? _this$props$categorie : null;
        var publishIn = _this.state.publishIn;

        if (categories !== null) {
          var _categoriesForPublish, _this$props$enabledLa, _this$props$published;

          var categoriesForPublishedIn = [];

          if (publishIn === 'knowledgeBase') {
            categoriesForPublishedIn = categories[(0, _categories.getTypeFromModuleName)(_categories.MODULE.KNOWLEDGE_BASE)];
          }

          if (publishIn === 'community') {
            categoriesForPublishedIn = categories[(0, _categories.getTypeFromModuleName)(_categories.MODULE.COMMUNITY)];
          }

          var languagesAssignedToCategories = Array.from(new Set((_categoriesForPublish = categoriesForPublishedIn) === null || _categoriesForPublish === void 0 ? void 0 : _categoriesForPublish.map(function (category) {
            return category.language;
          }).filter(function (language) {
            return language;
          }))); // Display languages only if a category is already assigned to that language

          _this.setState({
            resetSelectedLanguage: publishInUpdated,
            enabledLanguages: (_this$props$enabledLa = _this.props.enabledLanguages) === null || _this$props$enabledLa === void 0 ? void 0 : _this$props$enabledLa.filter(function (language) {
              return languagesAssignedToCategories.includes(language.code);
            }),
            publishedLanguages: (_this$props$published = _this.props.publishedLanguages) === null || _this$props$published === void 0 ? void 0 : _this$props$published.filter(function (language) {
              return languagesAssignedToCategories.includes(language.code);
            })
          });
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRadioInputChange", function (event) {
      if (!(0, _typeGuards.hasValueInEventTarget)(event)) return;
      var value = event.target.value;

      if (value === 'groups' || value === 'knowledgeBase' || value === 'community') {
        var _this$props$community;

        _this.setState({
          publishIn: value,
          selectedLanguageCode: (_this$props$community = _this.props.communityLanguage) === null || _this$props$community === void 0 ? void 0 : _this$props$community.code
        });
      }

      _this.props.onUpdate(undefined);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectCategory", function (category) {
      var onUpdate = _this.props.onUpdate;
      onUpdate(category.id);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectLanguage", function (languageCode) {
      _this.setState({
        selectedLanguageCode: languageCode,
        resetSelectedLanguage: false
      }, function () {
        _this.props.onUpdate(undefined);
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CategorySelect, [{
    key: "getInitialState",
    value: function getInitialState() {
      var _this$props$community2;

      var _this$props2 = this.props,
          categoryId = _this$props2.categoryId,
          categories = _this$props2.categories,
          isKnowledgeBaseEnabled = _this$props2.isKnowledgeBaseEnabled,
          isGroupsEnabled = _this$props2.isGroupsEnabled;
      var publishIn = 'community';

      if (categoryId) {
        var groupedCategories = (0, _utils2.groupCategories)(categories, isKnowledgeBaseEnabled, isGroupsEnabled);

        if (hasCategoryWithId(groupedCategories.groups, categoryId)) {
          publishIn = 'groups';
        } else if (hasCategoryWithId(groupedCategories.knowledgeBase, categoryId)) {
          publishIn = 'knowledgeBase';
        }
      }

      return {
        publishIn: publishIn,
        resetSelectedLanguage: true,
        selectedLanguageCode: (_this$props$community2 = this.props.communityLanguage) === null || _this$props$community2 === void 0 ? void 0 : _this$props$community2.code
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.filterLanguages(true);
    }
  }, {
    key: "render",
    value: function render() {
      var _category$title,
          _ref3,
          _groupedCategories$co,
          _groupedCategories$kn,
          _groupedCategories$gr,
          _this2 = this;

      var _this$props3 = this.props,
          error = _this$props3.error,
          hideLabel = _this$props3.hideLabel,
          categoryId = _this$props3.categoryId,
          categories = _this$props3.categories,
          isKnowledgeBaseEnabled = _this$props3.isKnowledgeBaseEnabled,
          isGroupsEnabled = _this$props3.isGroupsEnabled,
          communityLanguage = _this$props3.communityLanguage;
      var _this$state = this.state,
          publishIn = _this$state.publishIn,
          selectedLanguageCode = _this$state.selectedLanguageCode,
          enabledLanguages = _this$state.enabledLanguages,
          publishedLanguages = _this$state.publishedLanguages,
          resetSelectedLanguage = _this$state.resetSelectedLanguage;
      var groupedCategories = (0, _utils2.groupCategories)(categories, isKnowledgeBaseEnabled, isGroupsEnabled);
      var category = categoryId && categories ? (0, _utils.getCategory)(Object.values(categories).flat(), categoryId) : null;
      var categoryTitle = (_category$title = category === null || category === void 0 ? void 0 : category.title) !== null && _category$title !== void 0 ? _category$title : 'Select category';
      var filteredCategories = (_ref3 = categories && filterCategoriesByType(categories, publishIn, selectedLanguageCode)) !== null && _ref3 !== void 0 ? _ref3 : {};
      var showLanguageSelector = publishIn === 'knowledgeBase' || publishIn === 'community';
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('category-select', 'form-group', {
          error: error
        })
      }, !hideLabel && (0, _preact.h)("h2", {
        className: "category-select__heading"
      }, "Publish in *"), (0, _preact.h)("div", {
        className: "category-select__publish-in"
      }, (_groupedCategories$co = groupedCategories.community) !== null && _groupedCategories$co !== void 0 && _groupedCategories$co.length ? (0, _preact.h)("div", {
        className: "category-select__radio-box"
      }, (0, _preact.h)("input", {
        id: "communityCategory",
        className: "category-select__radio-box__input",
        type: "radio",
        name: "publishIn",
        onChange: this.handleRadioInputChange,
        value: "community",
        checked: publishIn === 'community'
      }), (0, _preact.h)("label", {
        className: "category-select__radio-box__label",
        htmlFor: "communityCategory"
      }, "Community")) : null, (_groupedCategories$kn = groupedCategories.knowledgeBase) !== null && _groupedCategories$kn !== void 0 && _groupedCategories$kn.length ? (0, _preact.h)("div", {
        className: "category-select__radio-box category-select__radio-box__knowledgeBase"
      }, (0, _preact.h)("input", {
        id: "knowledgeBaseCategory",
        className: "category-select__radio-box__input",
        type: "radio",
        name: "publishIn",
        onChange: this.handleRadioInputChange,
        value: "knowledgeBase",
        checked: publishIn === 'knowledgeBase'
      }), (0, _preact.h)("label", {
        className: "category-select__radio-box__label",
        htmlFor: "knowledgeBaseCategory"
      }, "Knowledge Base")) : null, (_groupedCategories$gr = groupedCategories.groups) !== null && _groupedCategories$gr !== void 0 && _groupedCategories$gr.length ? (0, _preact.h)("div", {
        className: "category-select__radio-box category-select__radio-box__groups"
      }, (0, _preact.h)("input", {
        id: "groupsCategory",
        className: "category-select__radio-box__input",
        type: "radio",
        name: "publishIn",
        onChange: this.handleRadioInputChange,
        value: "groups",
        checked: publishIn === 'groups'
      }), (0, _preact.h)("label", {
        className: "category-select__radio-box__label",
        htmlFor: "groupsCategory"
      }, "Groups")) : null), showLanguageSelector && (0, _preact.h)(_LanguageSelector.default, {
        communityLanguage: communityLanguage,
        enabledLanguages: enabledLanguages,
        publishedLanguages: publishedLanguages,
        resetSelectedLanguage: resetSelectedLanguage,
        fill: true,
        onLanguageSelected: function onLanguageSelected(languageCode) {
          return _this2.onSelectLanguage(languageCode);
        }
      }), (0, _preact.h)(_CategoryDropdown.default, {
        categories: filteredCategories,
        onSelectCategory: this.onSelectCategory,
        trigger: (0, _preact.h)(_Button.default, {
          title: categoryTitle,
          endIcon: "chevronDown",
          size: "medium",
          fullWidth: true,
          "data-qa": "select-category"
        }),
        triggerClass: "dropdown-selector-wrapper--control",
        searchable: true,
        searchPlaceholder: "Search in ".concat(getPublishingModule(publishIn))
      }));
    }
  }]);
  return CategorySelect;
}(_preact.Component);

exports.default = CategorySelect;